import MaterialIcon from '@components/common/MaterialIcon';
import KeywordBadge from '@components/train-ai/KeywordBadge';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface ArticleKeywordsSectionProps {
  keywords: string[];
}

export const ArticleKeywordsSection: React.FC<ArticleKeywordsSectionProps> = ({
  keywords,
}) => {
  const { t } = useTranslation();

  if (keywords.length === 0) {
    return null;
  }

  return (
    <div className='mt-3 bg-gray-50 border border-gray-200 rounded-xl p-3'>
      <div className='flex items-center gap-1.5 mb-2'>
        <MaterialIcon
          type='outlined'
          icon='sell'
          classes={['text-gray-400', 'text-sm']}
        />
        <span className='text-tiny font-medium text-gray-400 uppercase tracking-wide'>
          {t('article-architect.articles-tab.sidebar.keywords')}
        </span>
      </div>
      <div className='flex flex-wrap gap-2'>
        {keywords.map((keyword) => (
          <KeywordBadge key={keyword} keyword={keyword} />
        ))}
      </div>
    </div>
  );
};
